import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';


import './App.scss'


// Use createRoot to create a root
const root = createRoot(document.getElementById('root'));


// Call render on the root
root.render(
    <App />
  );